<template>
  <div class="intro-fullscreen" ref="container">
    <div class="intro-container">
      <div class="progress-dots-container">
        <div v-if="currentScreenIndex > 0" class="dots">
          <div class="dot" :class="{ filled: currentScreenIndex == 1 }"></div>
          <div class="dot" :class="{ filled: currentScreenIndex == 2 }"></div>
          <div class="dot" :class="{ filled: currentScreenIndex == 3 }"></div>
        </div>
      </div>
      <div class="content-container">
        <component :is="screens[currentScreenIndex]" />
      </div>
      <div class="button-container">
        <a @click="next" class="button throb" v-ripple>
          {{ buttons[currentScreenIndex] }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import Tutorial1 from '@/components/Tutorial1.vue'
import Tutorial2 from '@/components/Tutorial2.vue'
import Tutorial3 from '@/components/Tutorial3.vue'

export default {
  name: 'IntroScreen',
  components: { Title, Tutorial1, Tutorial2, Tutorial3 },
  data() {
    return {
      currentScreenIndex: 0,
      screens: ['Title', 'Tutorial1', 'Tutorial2', 'Tutorial3'],
      buttons: ['Start', 'Next', 'Next', "I'm ready"],
    }
  },
  unmounted() {
    console.log('IntroScreen unmounted')
  },
  methods: {
    next() {
      //if (this.currentScreenIndex + 1 < this.screens.length) {
      //  this.currentScreenIndex += 1
      //} else {
      this.$store.commit('SET_SHOW_INTRO_SCREEN', false)
      setTimeout(() => {
        this.$store.dispatch('play_level_start_anim')
      }, 500)
      //}
    },
  },
}
</script>

<style scoped>
.intro-fullscreen {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /*background-color: #003745;*/
  background-color: rgba(3, 28, 33, 1);
  z-index: 100;
}

.intro-container {
  width: 90%;
  max-width: 30rem;
  min-width: 16rem;
  /*margin-top: 10vh;
  margin-bottom: 10vh;*/
  height: 80%;
  min-height: 15rem;
  max-height: 35rem;
  display: flex;
  flex-direction: column;
  background-color: #003745;
  border-radius: 20px;
  /*border: 1px white solid;*/
}

.progress-dots-container {
  padding-top: 1rem;
  height: 2rem;
  width: 100%;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
}

.dots {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.dots > * + * {
  margin-left: 0.5rem;
}

.dot {
  border-radius: 50%;
  height: 0.7rem;
  width: 0.7rem;
  border: 1px solid #cdf4dd;
}

.filled {
  background-color: #cdf4dd;
}

.content-container {
  width: 100%;
  /*height: 80%;*/
  flex: 1 1 80%;
  /*background-color: coral;*/
}

.button-container {
  width: 100%;
  /*height: 20%;*/
  flex: 1 1 30%;
  /*background-color: darkgoldenrod;*/
  display: flex;
  justify-content: center;
  align-items: center;
}

.button {
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  max-width: 10em;
  width: 90%;
  display: block;
  padding: 1em;
  text-align: center;
  border: 1px solid #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
  -webkit-tap-highlight-color: transparent;
}

@media (hover: hover) {
  .button:hover {
    background-color: rgba(204, 244, 221, 0.1);
  }
}

/*.button:focus {
  background-color: transparent;
}*/

.button.throb {
  animation-name: button-throb-animation;
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center;
}

@keyframes button-throb-animation {
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(224, 168, 0, 0.3);
  }
}
</style>
